import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import UpdateFeed from "../../Presentational/ItemUpdate/UpdateFeed";
import FilterBox from "./StudentFilterUpdateFeedFilters/FilterBox";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import ActivityService from "../../../Services/Activity.service";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import PermissionBoundary from "../../UI/PermissionBoundary/PermissionBoundary";
const maxStudentsAllowed = 10000;
// We could probably create a utility to do this, but for now, just hard-code it.
const maxStudentsAllowedAsString = "10,000";
const StudentFilterUpdateFeed = (props) => {
    const [filterBoxFilters, setFilterBoxFilters] = React.useState(null);
    // The filter box which this component uses will set the filters once it mounts.  We don't want to load
    // activity feed filters until after we it's set, otherwise we'll end up loading it twice.
    // We use this state variable to keep track of whether it has been set by the filter.
    const [receivedFilterFromBox, setReceivedFilterFromBox] = React.useState(false);
    const itemSearch = React.useMemo(() => {
        if (filterBoxFilters) {
            return Object.assign(Object.assign({}, filterBoxFilters), { global: Object.assign(Object.assign({}, filterBoxFilters.global), { contextPeopleFilterId: props.filterId }) });
        }
        if (!receivedFilterFromBox) {
            return null;
        }
        return {
            global: {
                contextPeopleFilterId: props.filterId,
            },
            latestValue: [],
        };
    }, [filterBoxFilters, props.filterId, receivedFilterFromBox]);
    const onFilter = React.useCallback((filter) => {
        setReceivedFilterFromBox(true);
        setFilterBoxFilters(filter);
    }, []);
    const [canAccessActivityFeedState, getCanAccessActivityFeed] = useService(ActivityService.canAccessActivityFeed);
    useEffect(() => {
        getCanAccessActivityFeed(props.filterId);
    }, [getCanAccessActivityFeed, props.filterId]);
    const shouldShowUpdateFeed = canAccessActivityFeedState.data &&
        props.numPeopleReturnedByFilter < maxStudentsAllowed;
    return (_jsx(ServiceResult, { state: canAccessActivityFeedState, children: (canAccessActivityFeed) => (_jsx(PermissionBoundary, { children: _jsx("div", { children: shouldShowUpdateFeed ? (_jsx(UpdateFeed, { search: itemSearch, pageSize: 25, showStudentInPath: true, filterComponent: _jsx(FilterBox, { onFilter: onFilter }), noEventsMessage: "No activity found in the last 90 days." })) : (_jsx(AlertInfo, { message: 
                    // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'boolean'.
                    !canAccessActivityFeed.data
                        ? "You do not have permission to access the activity feed for this filter"
                        : `A feed can only be displayed for a filter of less than ${maxStudentsAllowedAsString} people`, center: true })) }) })) }));
};
export default StudentFilterUpdateFeed;
